var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quick-text-message"},[(_vm.msgItem.systemType === 'enterRoom')?_c('div',[_c('span',[_vm._v(" "+_vm._s(_vm.msgItem.nickname))]),_c('span',[_vm._v(" 已进入课堂")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }